import { GiftCardsState } from './types'

export const initialGiftCardsState: GiftCardsState = {
  providers: {},
  selectedProviderId: null,
}
